module.exports = __webpack_public_path__ + "images/emoji/ticket.2716481da3574aca1f6d.png";